<template>
  <div class='echart' id='myEcharts2' />
</template>
<script>
  import echarts from 'echarts';
  import domToImage from 'dom-to-image';

  export default {
    data() {
      return {
        charts: null,
        xData: [],
        Echart: [
          {
            name: '2020年',
            color: '#FFFFFF',
            data: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120],
          },
          {
            name: '2021年',
            color: '#FFFFFF',
            data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
          },
        ],
        options: {
          backgroundColor: '#FFF',
          title: {
            text: '商品车月运量（辆）对比表',
            textStyle: {
              color: '#000',
              fontSize: 20,
              fontWeight: 'bold',
            },
            top: 50,
            left: 'center',
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
              textStyle: {
                color: '#000000',
              },
            },
          },
          grid: {
            borderWidth: 0,
            top: 110,
            bottom: 95,
            textStyle: {
              color: '#000000',
            },
          },
          legend: {
            x: 'center',
            top: '11%',
            textStyle: {
              color: '#000000',
            },
            data: ['访问量', '订单量'],
          },
          calculable: true,
          xAxis: [{
            type: 'category',
            axisLine: {
              lineStyle: {
                color: '#00000',
              },
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          }],
          yAxis: [{
            type: 'value',
            splitLine: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: '#000000',
              },
            },

          }],
          dataZoom: [{
            show: true,
            height: 30,
            xAxisIndex: [0],
            bottom: 30,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '100%',
            handleStyle: {
              color: '#5B3AAE',
            },
            textStyle: {
              color: 'rgba(204,187,225,0.5)',
            },
            fillerColor: 'rgba(67,55,160,0.4)',
            borderColor: 'rgba(204,187,225,0.5)',

          }, {
            type: 'inside',
            show: true,
            height: 15,
            start: 1,
            end: 35,
          }],
          series: [{
            name: '访问量',
            type: 'line',
            symbolSize: 10,
            symbol: 'circle',
            itemStyle: {
              color: '#6f7de3',
            },
            markPoint: {
              label: {
                normal: {
                  textStyle: {
                    color: '#fff',
                  },
                },
              },
            },
            data: [
              509, 917, 2455, 2610, 2719, 3033, 3044, 3085, 2708, 2809, 2117, 2000,
            ],
          }, {
            name: '订单量',
            type: 'line',
            symbolSize: 10,
            symbol: 'circle',
            itemStyle: {
              color: '#c257F6',
            },
            markPoint: {
              label: {
                normal: {
                  textStyle: {
                    color: '#fff',
                  },
                },
              },
            },
            data: [
              2136, 3693, 2962, 3810, 3519, 3484, 3915, 3823, 3455, 4310, 4019, 3433,
            ],
          }],
        },
      };
    },
    methods: {
      init(arr) {
        console.log(arr);
        this.options.series = [];
        const names = [];
        arr.forEach(item => {
          this.options.series.push({
            name: item.name,
            type: 'line',
            symbolSize: 10,
            symbol: 'circle',
            itemStyle: {
              color: item.color,
            },
            markPoint: {
              label: {
                normal: {
                  textStyle: {
                    color: '#fff',
                  },
                },
              },
            },
            data: item.data,
          });
          names.push(item.name);
        });
        this.options.legend.data = names;
        this.charts.setOption(this.options, true);
      },
      async exportData(url, exportParams) {
        const myEcharts = document.getElementById('myEcharts2');
        exportParams.file = await domToImage.toPng(myEcharts);
        window.exportExcel(url, exportParams, '月运量图表分析导出');
        this.$emit('pageLoadingChange', false);
      },
    },
    mounted() {
      this.charts = echarts.init(document.getElementById('myEcharts2'));
      window.addEventListener('resize', this.charts.resize, false);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.charts.resize, false);
    },
  };
</script>
<style lang='scss' scoped>
  .echart {
    width: 100%;
    height: 100%;
  }
</style>
